module.exports = __webpack_public_path__ + "static/media/learning-1.beea9398.svg";